import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getApi } from "../../../Services/apiService";

const UserDetail = () => {
  const { id } = useParams(); // Get user ID from URL
  const location = useLocation();

  const [userDetails, setUserDetails] = useState(null);
  const [followers, setFollowers] = useState([]);
  console.log("followers",followers);
  
  const [following, setFollowing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatDate = (timestamp) => {
    if (!timestamp) return 'NA';

    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.toLocaleString('en-GB', { month: 'long' });
    const year = date.getFullYear();

    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    return `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
  };
  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!id) return; // Avoid API call if id is missing

      setLoading(true);
      setError(null);

      try {
        const response = await getApi(`/admin/user-details/${id}`);

        if (response?.status === 200) {
          setUserDetails(response.data.user);
          setFollowers(response.data.followers);
          setFollowing(response.data.following);
        } else {
          throw new Error("Failed to fetch user details.");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, [id]);

  return (
    <div className="car-care-tips user-detail">
    <div className={`${location.pathname.includes('user-management') ? 'RightSideDiv' : ''} ${loading ? 'blurred' : ''}`}>
      <div className=""></div>
      <h2 className="detail-heading">User Details</h2>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : userDetails ? (
        <div className="user-info">
          <div className="user-details-section">
          <span>
                  <img
                    src={userDetails.image || window.getPublicUrl("/assets/images/dummy-profile.jpg")}
                    alt="Profile"
                    className="profile-thumbnail"
                  />
                </span>

               <div className="user-name">
               <h2><strong></strong> {userDetails.name || "NA"}</h2>
               <h3><strong></strong> {userDetails.user_name || "NA"}</h3>
               </div>

            <ul>
              
             
              <li><strong>Email:</strong> {userDetails.email || "NA"}</li>
              <li><strong>Joined On:</strong> {formatDate(userDetails?.createdAt)}</li>
              <li>
                <strong>Gender:</strong> {userDetails.gender == 0 ? "Male" : userDetails.gender == 1 ? "Female" : "Other"}
              </li>
            </ul>
          </div>

          <div className="follow-section">
            {/* Followers List */}
<div className="row">

            <div className="col-sm-6">  
            <div className="followers-list">
  <h3>Followers</h3>
  {followers.length > 0 ? (
    <ul>
      {followers.map((follower) => (
        <li key={follower.id}>
            <span>
                        <img
                          src={follower?.followers_detail?.image || window.getPublicUrl("/assets/images/dummy-profile.jpg")}
                          alt="Profile"
                          className="profile-thumbnail"
                        />
                        </span>
         <div className="follow-text">               
         <h1>
         {follower?.followers_detail?.name}
          </h1> 
          <h3>
          {follower?.followers_detail?.user_name} 
            </h3>
            </div>
        </li>
      ))}
    </ul>
  ) : (
    <p>No followers found.</p>
  )}
</div>
</div>


            {/* Following List */}
            <div className="col-sm-6">
            <div className="followers-list">
              <h3>Following</h3>
              {following.length > 0 ? (
                <ul>
                  {following.map((follow) => (
                    <li key={follow.id}>
                      <span>
                      <img src={follow?.following_detail?.image || "/assets/images/dummy-profile.jpg"} alt="Following" className="small-profile-pic" />
                      </span>
                      <div className="follow-text">
                    <h1> {follow?.following_detail?.name}</h1>
                      
                      <h3>{follow?.following_detail?.user_name}</h3>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>Not following anyone.</p>
              )}
            </div>
            </div>
          </div>
          </div>
        </div>
      ) : (
        <p>No user details available.</p>
      )}
    </div>
    </div>
  );
};

export default UserDetail;
